export default __webpack_public_path__ + "static/media/prize-1.7deed69d.webp";